export default "__VITE_ASSET__Bj2zs6kx__"